import React, { useCallback, useEffect, useState } from "react";
import PhotographerTable from "../PhotographerTable/PhotographerTable";
import "./UnverifiedPhotographerTable.css";
import AddPhotographerModal from "../AddPhotographerModal/AddPhotographerModal";
import { getUnverifiedPhotographersAPI } from "../../../utils/APIs/photographersApis";
import Loader from "../../../Loader/Loader";

const UnverifiedPhotographerTable = () => {
  const [unverifiedData, setUnverifiedData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const LIMIT = 10


  const fetchData = useCallback(async (pageNo = page) => {
    setLoading(true);
    try {
      const res = await getUnverifiedPhotographersAPI(pageNo, LIMIT);
      console.log("RESPONSE", res?.data)

      setUnverifiedData(res?.data?.photographers || []);
      setTotal(res.data?.meta?.total || 0);
      setPage(res.data?.meta?.page || pageNo);
    } catch (err) {
      console.error("Previous bookings fetch failed", err);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchData(1);
  }, [fetchData]);

  console.log("UNVERIFIED PHOTOGRAPPHER", unverifiedData)
  const handleAddPhotographer = (photographer) => {
    // If user is on first page, prepend
    if (page === 1) {
      setUnverifiedData((prev) => [photographer, ...prev.slice(0, LIMIT - 1)]);
    } else {
      // Otherwise, refetch current page
      fetchData(page);
    }

    setTotal((prev) => prev + 1);
  };


  const totalPages = Math.ceil(total / LIMIT);
  const getPageNumbers = () => {
    let start;

    if (page <= 2) {
      start = 1;
    } else if (page >= totalPages - 1) {
      start = totalPages - 2;
    } else {
      start = page - 1;
    }

    return Array.from({ length: 3 }, (_, i) => start + i)
      .filter(p => p >= 1 && p <= totalPages);
  };
  if (loading) {
    return <Loader />
  }

  return (
    <div>
      <div className="table-header">
        <  button
          className="btn-add-photographer"
          onClick={() => setIsAddModalOpen(true)}
        >
          + Add Photographer
        </button>
      </div>

      <PhotographerTable data={unverifiedData} showVerify={true} page={page} limit={LIMIT} refreshData={() => fetchData(page)} />
      {/* Pagination */}

      {total > LIMIT && (
        <div className="pagination">
          {/* Prev */}
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          {/* Page Numbers */}
          {getPageNumbers().map((p) => (
            <button
              key={p}
              className={`pagination-btn ${p === page ? "active" : ""}`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}

          {/* Next */}
          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}

      <AddPhotographerModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onAdd={handleAddPhotographer}
      />
    </div>
  );
};

export default UnverifiedPhotographerTable;
